import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "info-container" }
const _hoisted_2 = { class: "column items-center q-gutter-sm q-mb-lg" }
const _hoisted_3 = { class: "row" }

import { useRouter } from 'vue-router'
import { ref } from 'vue'
import AppointmentPicker from '@/components/AppointmentPicker.vue'
import {Appointment} from "@/models/appointment";


export default /*@__PURE__*/_defineComponent({
  __name: 'SelectAppointment',
  setup(__props) {

const router = useRouter()
const appointment = ref<Appointment | null>(null)
const selected = ref<any>(null)

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(AppointmentPicker, {
        modelValue: appointment.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((appointment).value = $event)),
        "onUpdate:selectedAppointment": _cache[1] || (_cache[1] = ($event: any) => (selected.value = $event))
      }, null, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_q_btn, {
          "no-caps": "",
          flat: "",
          size: "lg",
          color: "primary",
          label: "Zrück",
          icon: "arrow_back_ios",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).back()))
        }),
        _createVNode(_component_q_btn, {
          "no-caps": "",
          flat: "",
          size: "lg",
          color: "primary",
          label: "Weiter",
          "icon-right": "arrow_forward_ios",
          to: `/de/pay?a=${appointment.value?.id}&s=${appointment.value?.start.getTime()}`
        }, null, 8, ["to"])
      ]),
      _createVNode(_component_q_btn, {
        "no-caps": "",
        flat: "",
        size: "sm",
        color: "primary",
        class: "legal-button",
        label: "Impressum und Datenschutzerklärung",
        to: "/de/datenschutz-impressum"
      })
    ])
  ]))
}
}

})